export default "__VITE_ASSET__mXcqK3r9__"